import { Component, OnInit } from '@angular/core';
import { HotelModel } from '../../models/hotel.model';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { AsyncFunctionsService } from '../../shared/services/async-functions.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/state/app.state';
import { FunctionsService } from '../../shared/services/functions.service';
import { ToastService } from '../../shared/services/toast.service';
import { CacheService } from '../../shared/services/cache.service';
import { HttpService } from '../../shared/services/http.service';

@Component({
  selector: 'app-display-hotels',
  templateUrl: './display-hotels.component.html',
  styleUrls: ['./display-hotels.component.scss']
})
export class DisplayHotelsComponent implements OnInit {
  partners: HotelModel[] = [];
  hotelsPos: HotelModel[] = [];
  allHotels: HotelModel[] = [];
  employeeId = this.functions.getLoggedInUserId();

  // 🔍 Filters
  hotelSearchTerm: string = '';
  statusFilter: string = 'active';
  sortedHotels: HotelModel[] = [];
  filteredPartners: HotelModel[] = [];
  partnerTypeFilter: string = 'all';
  partnerTypes: string[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private asyncFunctions: AsyncFunctionsService,
    private functions: FunctionsService,
    private store: Store<AppState>,
    private toastService: ToastService,
    private cacheService: CacheService,
    private httpService: HttpService
  ) {}

  ngOnInit(): void {
    this.partners = this.asyncFunctions.getEmployeeAccessHotels();
    this.store.select('hotels').subscribe((res) => {
      this.partners = res;
      if (this.partners) {
        this.hotelsPos = [...this.partners];
      }
      this.allHotels = res;
      console.log('this.allHotels', this.allHotels);
      this.sortHotels();
    });
  }
  formatPhoneNumber(phone: string): string {
    if (!phone) { return ''; }
    let formatted = phone;
    if (phone.startsWith('234')) {
      formatted = phone.replace(/^234/, '');
    }
    if (!formatted.startsWith('0')) {
      formatted = '0' + formatted;
    }
    return formatted;
  }


  // ✅ Computed Filtered Lists
  // get filteredPartners(): gHotelModel[] {
  //   if (!this.allHotels) {
  //     return [];
  //   }
  //   return this.allHotels.filter(hotel => this.applyHotelFilters(hotel));
  // }
  sortHotels() {
    if (!this.allHotels || !Array.isArray(this.allHotels)) {
      return;
    }

    const HQ_NAME = 'HQ_HQ_Vitel HQ';

    const hqHotel = this.allHotels.find(h => h?.hotelName === HQ_NAME);

    const otherHotels = this.allHotels
      .filter(h => h?.hotelName && h.hotelName !== HQ_NAME)
      .sort((a, b) =>
        (a.hotelName || '').localeCompare(b.hotelName || '')
      );

    this.sortedHotels = hqHotel ? [hqHotel, ...otherHotels] : otherHotels;

    // console.log('this.sortedHotels', this.sortedHotels);

    // ✅ ADD THIS LINE
    this.setPartnerTypes();

    this.applyFilters();
  }

// ✅ Extract unique partner types
  setPartnerTypes(): void {
    this.partnerTypes = [
      ...new Set(
        this.sortedHotels
          .map(hotel => (hotel.partnerType || '').trim())
          .filter(type => !!type)
      )
    ].sort((a, b) => a.localeCompare(b));
  }

// ✅ Core Filtering Logic
  applyHotelFilters(hotel: HotelModel): boolean {
    const searchTerm = (this.hotelSearchTerm || '').toLowerCase().trim();

    const matchesSearch =
      !searchTerm ||
      (hotel.hotelName || '').toLowerCase().includes(searchTerm) ||
      (hotel.partnerCode || '').toLowerCase().includes(searchTerm);

    const hotelStatus = (hotel.status || 'active').toLowerCase();
    const matchesStatus =
      this.statusFilter === 'all' || this.statusFilter === hotelStatus;

    const hotelType = (hotel.partnerType || '').toLowerCase().trim();
    const selectedType = (this.partnerTypeFilter || 'all').toLowerCase().trim();

    const matchesType =
      selectedType === 'all' || hotelType === selectedType;

    return matchesSearch && matchesStatus && matchesType;
  }

  applyFilters() {
    this.filteredPartners = this.sortedHotels.filter(hotel => this.applyHotelFilters(hotel));
    // console.log('this.filteredPartners', this.filteredPartners);
    // console.log('this.sortedHotels', this.sortedHotels);
  }

  proceedToDashboard(hotel: HotelModel) {
    // console.log('hotel<<<<<<<<', hotel);
    if (!hotel.fbAccessRole) {
      this.showToast(
        'Error!',
        'You need an access role to access this location. Please ask admin to assign an access role to you.'
      );
    } else {
      localStorage.setItem('current:hotel', JSON.stringify(hotel));
      this.updateLoginDetails(hotel);
      // console.log('hotelmmmmmmm', hotel);
      this.router.navigate(['/dashboard']);
    }
  }

  proceedToPos(hotel: HotelModel, disabled: boolean) {
    if (!disabled) {
      const [currentHotel] = this.partners.filter(
        (e) => e.hotelId === hotel.hotelId
      );
      if (this.cacheService.currentPOS.hotel !== currentHotel.hotelId) {
        this.cacheService.currentPOS.hotel = currentHotel.hotelId;
        this.cacheService.currentPOS.location = 0;
      }
      localStorage.setItem('current:hotel', JSON.stringify(currentHotel));
      this.router.navigate(['/pos/dashboard']);
      this.updateLoginDetails(hotel);
    }
  }

  updateLoginDetails(hotel: HotelModel) {
    const details = {
      employeeId: this.employeeId,
      hotelId: hotel.hotelId
    };
    this.httpService.helperPut(`employees/updateLogin`, details).subscribe(
      () => {},
      (err) => {
        console.log(err);
      }
    );
  }

  logOut() {
    this.authService.logOut();
  }

  showToast(header, message) {
    this.toastService.show(message, header, {
      classname: 'bg-danger text-light',
      delay: 10000
    });
  }
}
